import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { isAuthenticated } from '../../utils/auth';
import {
    enablePushNotificationsFromUserGesture,
    getNotificationDiagnostics,
} from '../../utils/browserNotifications';
import './NotificationPermissionPrompt.css';
import Icon from '../common/Icon';

const DISMISSED_KEY = 'push_permission_prompt_dismissed_v1';

const NotificationPermissionPrompt = () => {
    const location = useLocation();
    const [visible, setVisible] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        if (!isAuthenticated() || localStorage.getItem(DISMISSED_KEY) === 'true') {
            setVisible(false);
            return undefined;
        }

        const diagnostics = getNotificationDiagnostics();
        if (
            !diagnostics.isStandalone ||
            !diagnostics.hasNotificationApi ||
            !diagnostics.hasServiceWorkerApi ||
            !diagnostics.hasPushApi ||
            diagnostics.permission !== 'default'
        ) {
            setVisible(false);
            return undefined;
        }

        const timeoutId = window.setTimeout(() => setVisible(true), 900);
        return () => window.clearTimeout(timeoutId);
    }, [location.pathname]);

    const handleEnable = async () => {
        setSubmitting(true);
        setError('');
        try {
            await enablePushNotificationsFromUserGesture();
            localStorage.setItem(DISMISSED_KEY, 'true');
            setVisible(false);
        } catch (enableError) {
            setError(enableError.message || 'Не удалось включить уведомления.');
        } finally {
            setSubmitting(false);
        }
    };

    const handleLater = () => {
        localStorage.setItem(DISMISSED_KEY, 'true');
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <div className="notification-prompt-overlay" role="presentation">
            <section
                className="notification-prompt"
                role="dialog"
                aria-modal="true"
                aria-labelledby="notification-prompt-title"
            >
                <div className="notification-prompt-icon">
                    <Icon name="bell" />
                </div>
                <h2 id="notification-prompt-title">Включить уведомления?</h2>
                <p>
                    Получайте напоминания и изменения по заказам, даже когда приложение закрыто.
                </p>

                {error && <div className="notification-prompt-error">{error}</div>}

                <div className="notification-prompt-actions">
                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={handleEnable}
                        disabled={submitting}
                    >
                        {submitting ? 'Подключение...' : 'Включить уведомления'}
                    </button>
                    <button
                        type="button"
                        className="btn btn-light"
                        onClick={handleLater}
                        disabled={submitting}
                    >
                        Позже
                    </button>
                </div>
            </section>
        </div>
    );
};

export default NotificationPermissionPrompt;
